export type SvgIconProps = {
  children?: React.ReactNode
  className?: string
  fillColor?: string
  size?: number
  height?: number
  width?: number
  strokeColor?: string
  strokeWidth?: number
  viewBox?: string
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
}

export const SvgIcon = ({
  children,
  className,
  fillColor = "none",
  height = 0,
  onClick,
  size = 32,
  strokeColor = "currentColor",
  strokeWidth = 1,
  viewBox = "0 0 24 24",
  width = 0,
}: SvgIconProps) => {
  // if a specific width or height is set then use that, or we default those values to size

  const w = width > 0 ? width : size
  const h = height > 0 ? height : size

  return (
    <svg
      className={className}
      fill={fillColor}
      height={h}
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      viewBox={viewBox}
      width={w}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      // The shape-rendering attribute controls how SVG shapes are rendered.
      // 'geometricPrecision' tells the browser to optimize for precise rendering,
      // which can help produce sharper lines for vector artwork.
      shapeRendering="geometricPrecision"
      // The text-rendering attribute controls the rendering of any text within SVGs.
      // 'geometricPrecision' ensures that text in SVGs, if used, is rendered sharply.
      textRendering="geometricPrecision"
      // The image-rendering attribute instructs the browser how to handle images in SVGs.
      // 'auto' will generally allow for optimal smoothing, but 'optimizeQuality' or 'crisp-edges'
      // can also be options for bitmaps. For vector icons, 'auto' is appropriate.
      imageRendering="auto"
    >
      {children}
    </svg>
  )
}
